import { ProductOrBrand } from "./alternativeTypes";

export const foodAndSnacksProducts: ProductOrBrand[] = [
  {
    name: "Mondelēz",
    include: false, // Prioritising brands over owner who's less known
    ownerCountry: "US",
    categories: ["food-and-snacks"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mondelez_International"],
  },
  {
    name: "Своге",
    ownerCountry: "US",
    availableIn: ["BG"],
    comments: "Mondelēz owned",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://fabrikasvoge.com"],
  },
  {
    name: "Marabou",
    ownerCountry: "US",
    availableIn: [
      "AU", "AT", "CA", "CZ", "DE", "IS", "NL", "PT",
      "ES", "CH", "TR", "IE", "UK"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mondelez_International"],
  },
  {
    name: "Freia",
    ownerCountry: "US",
    headquarterIn: "NO",
    businessInRussia: "continuing",
    comments: "Eieren Mondelēz fortsetter sin business i Russland",
    availableIn: ["NO"],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Freia_(chocolate)"],
  },
  {
    name: "Hershey's",
    ownerCountry: "US",
    availableIn: ["CA"],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/The_Hershey_Company"],
  },
  {
    name: "Toblerone",
    ownerCountry: "US",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Toblerone"],
  },
  {
    name: "Milka",
    ownerCountry: "US",
    availableIn: ["NL", "DE", "UK"],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Milka"],
  },
  {
    name: "Côte d'Or",
    ownerCountry: "US",
    comments: "Mondelēz",
    availableIn: ["NL", "DE"],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://nl.wikipedia.org/wiki/Côte_d%27Or_(chocolade)"],
  },
  {
    name: "Ritz",
    ownerCountry: "US",
    categories: ["food-and-snacks", "crackers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Ritz_Metro"],
  },
  {
    name: "Oreo",
    ownerCountry: "US",
    categories: ["food-and-snacks", "crackers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Oreo"],
  },
  {
    name: "Kellogg's",
    ownerCountry: "US",
    categories: ["food-and-snacks", "cereal"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kellogg%27s"],
  },
  {
    name: "Heinz",
    ownerCountry: "US",
    categories: ["food-and-snacks", "ketchup"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Heinz"],
  },
  {
    name: "Pringles",
    ownerCountry: "US",
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Pringles"],
  },
  {
    name: "Doritos",
    ownerCountry: "US",
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Doritos"],
  },
  {
    name: "Walkers",
    ownerCountry: "US", // Pepsico Holdings
    headquarterIn: "UK",
    availableIn: [
      "UK", "IE", // TODO investigate
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Walkers_(snack_foods)"],
  },
  {
    name: "Lay's",
    ownerCountry: "US", // Pepsico Holdings
    availableIn: [
      "UK", "IE", "BE", "NL", "LU",
      "CA", "MX", "FR", "DE", "GR",
      "PL", "RO"
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Lay%27s"],
  },
  {
    name: "Kettle",
    ownerCountry: "US",
    availableIn: [
      "UK", 
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kettle_Foods"],
  },
  {
    name: "Tyrells",
    ownerCountry: "DE", // Intersnack
    availableIn: [
      "UK", "AU", "DE"
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://www.just-food.com/news/intersnack-snaps-up-tyrrells-crisp-brand-from-hershey/"],
  },
  {
    name: "Mars",
    ownerCountry: "US",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mars_Inc."],
  },
  {
    name: "Snickers",
    ownerCountry: "US",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Snickers"],
  },
  {
    name: "M&M's",
    ownerCountry: "US",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/M%26M%27s"],
  },
  {
    name: "Philadelphia",
    ownerCountry: "US",
    categories: ["food-and-snacks", "cheese"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Philadelphia_Cream_Cheese"],
  },

  {
    name: "Orkla",
    ownerCountry: "NO",
    include: false, // Not prioritising owner companies over their brands
    availableIn: [
      "NO", "IS", "DK", "SE", "FI",
      "EE", "LT", "LV"
    ],
    categories: ["food-and-snacks"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Orkla_ASA"],
  },
  {
    name: "Pobeda",
    ownerCountry: "BG",
    availableIn: [
      "BG", 
    ],
    categories: ["food-and-snacks", "crackers"],
    sourceLinks: ["https://www.pobeda.bg"],
  },
  {
    name: "Ferrero",
    ownerCountry: "IT",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Ferrero_(company)"],
  },
  {
    name: "Tayto",
    ownerCountry: "DE",
    headquarterIn: "IE",
    availableIn: [
      "IE"
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Tayto_(Republic_of_Ireland)"],
  },
  {
    name: "Nidar",
    ownerCountry: "NO",
    availableIn: [
      "NO",
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Nidar"],
  },
  {
    name: "Lindt",
    ownerCountry: "CH",
    // "NL", "CH", "DE", "UK", "NO", "PL", "FR" These are researched, but seems to be available everywhere
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://nl.wikipedia.org/wiki/Lindt_(bedrijf)"],
  },
  {
    name: "Fazer",
    ownerCountry: "FI",
    availableIn: [
      "NO", "SE", "EE", "LV", "DK", "LT", "FI",
      "PL", "CZ"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fazer"],
  },
  {
    name: "Prana",
    ownerCountry: "CA",
    availableIn: [
      "CA"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://pranafoods.ca"],
  },
  {
    name: "Cloetta",
    ownerCountry: "SE",
    availableIn: [
      "SE", "FI", "NO", "DK", "NL", "DE", "UK"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Cloetta"],
  },
  {
    name: "Poulain",
    ownerCountry: "FR",
    availableIn: [
      "FR"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/Chocolat_Poulain"],
  },
  {
    name: "Andros",
    ownerCountry: "FR",
    availableIn: [
      "FR"
    ],
    comments: "Various foods, fruit, dairy and crackers",
    categories: ["food-and-snacks", "crackers"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/Andros_(entreprise)"],
  },
  {
    name: "Maître Prunille",
    ownerCountry: "FR",
    availableIn: [
      "FR"
    ],
    comments: "Nuts and stuff",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://www.maitreprunille.com"],
  },
  
  {
    name: "Malaco",
    ownerCountry: "SE",
    availableIn: [
      "SE", "FI", "NO", "DK", "NL"
    ],
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Malaco"],
  },
  {
    name: "OLW",
    ownerCountry: "SE",
    availableIn: [
      "SE", "FI", "NO", "DK"
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/OLW"],
  },
  {
    name: "Dare",
    ownerCountry: "CA",
    availableIn: [
      "CA",
    ],
    categories: ["food-and-snacks", "crisps", "crackers"],
    sourceLinks: ["https://www.darefoods.com"],
  },
  {
    name: "Haribo",
    ownerCountry: "DE",
    categories: ["food-and-snacks", "treats"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Haribo"],
  },
  {
    name: "AXA",
    ownerCountry: "SE",
    availableIn: [
      "SE", "FI", "NO", "DK"
    ],
    categories: ["food-and-snacks", "cereal"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/AXA"],
  },
  {
    name: "One Degree",
    ownerCountry: "CA",
    availableIn: [
      "CA"
    ],
    categories: ["food-and-snacks", "cereal"],
    sourceLinks: ["https://onedegreeorganics.com/"],
  },
  {
    name: "KiMs",
    ownerCountry: "NO",
    availableIn: [
      "SE", "FI", "NO", "DK", "IS"
    ],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/KiMs_A/S"],
  },
  {
    name: "Idun",
    ownerCountry: "NO",
    availableIn: [
      "NO"
    ],
    categories: ["food-and-snacks", "ketchup"],
    sourceLinks: ["https://www.idunklassikere.no/om-oss/"],
  },
  {
    name: "Wasa",
    ownerCountry: "IT",
    headquarterIn: "SE",
    availableIn: [
      "SE", "FI", "NO", "DK"
    ],
    categories: ["food-and-snacks", "crackers"],
    sourceLinks: ["https://sv.wikipedia.org/wiki/Wasabröd"],
  },
  {
    name: "Barilla",
    ownerCountry: "IT",
    categories: ["food-and-snacks"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Barilla_(company)"],
  },
  {
    name: "Maarud",
    ownerCountry: "DE", // Intersnack
    headquarterIn: "NO",
    availableIn: ["NO"],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://no.wikipedia.org/wiki/Maarud"],
  },
  {
    name: "Estrella",
    ownerCountry: "DE", // Intersnack
    headquarterIn: "SE",
    availableIn: ["SE", "FI"],
    categories: ["food-and-snacks", "crisps"],
    sourceLinks: ["https://da.wikipedia.org/wiki/Estrella_(chips)"],
  },
  {
    name: "Taffel",
    ownerCountry: "DE", // Intersnack
    availableIn: ["EE", "LT", "LV", "DK"],
    categories: ["food-and-snacks", "crisps"],
  },
  {
    name: "Tine",
    ownerCountry: "NO",
    availableIn: [
      "NO"
    ],
    categories: ["food-and-snacks", "cheese"],
  },
  {
    name: "Arla",
    ownerCountry: "DK",
    availableIn: [
      "SE", "FI", "NO", "DK", "UK", "DE"
    ],
    categories: ["food-and-snacks", "cheese"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Arla_Foods"],
  },
  {
    name: "Bel",
    ownerCountry: "FR", 
    availableIn: ["FR", "UK", "DE", "ES", "IT", "NL", "CH", "BE"], // Asked Le Chat
    categories: ["food-and-snacks", "cheese"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Bel_Group"],
  },
  // Will not include Danone on either side, because they're French registered, but:
  // Ownership of Danone is split as follows: 43% is owned by American investors, 
  // 19% by French investors, followed by the UK (10%), Switzerland (6%), Germany (5%) and the rest of Europe (17%).[58]  
];